var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "flex",
        class: {
          "items-center": !_vm.description,
          "items-start": _vm.description,
        },
      },
      [
        _c("input", {
          staticClass:
            "form-radio h-4 w-4 text-primary-600 transition duration-150 ease-in-out",
          attrs: { id: _vm.id, name: _vm.name, type: "radio" },
          domProps: { checked: _vm.isChecked },
          on: {
            input: function ($event) {
              return _vm.$emit("input", _vm.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-3", class: { "-mt-px": _vm.description } },
          [
            _c(
              "label",
              {
                attrs: { for: _vm.id },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("input", _vm.value)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "block text-sm leading-5 font-medium text-gray-700",
                  },
                  [_vm._t("default")],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _vm.description
              ? _c(
                  "p",
                  {
                    staticClass: "text-gray-500 text-sm",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", _vm.value)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.description) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }